<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="FchHc_1d02"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import FchHc_1d02 from '@/device-products/FchHc_1d02.vue';
import DdsSensor from '@/device-products/DdsSensor.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
          {
            id: 'Regler zu RCS 1',
            from: { deviceId: 0, uart: 0},
            to: { deviceId: 1, uart: 0},
          }
          ],
      },
      {
        label: 'GPSlave', connections: [
        ],
      },
      {
        label: 'DDS', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: FchHc_1d02, deviceLabel: null },
      { id: 1, component: DdsSensor, deviceLabel: 'RCS 1', deviceColor: 'green darken-2', props: {
        defaultSubAddress: '1',
        defaultSensorType: 'RCS',
        allowedSensorTypes: ['RCS'],
        defaultValues: [
          { conversion: 'rawTemperature', value: 22.0 },
          { conversion: 'rawHumidity', value: 20.0 },
          { conversion: 'rawPercent', value: 50.0 },
          { fieldIndex: 3, value: 0 },
          { conversion: 'rawPressure', value: 1.0 },
          { conversion: 'rawIaq', value: 100.0 },
          { fieldIndex: 6, value: 0 },
          { fieldIndex: 7, value: 7 },
        ],
      }},
    ],
  }),
};
</script>

<style>

</style>
